
        var result = require("!!../../../node_modules/css-loader/index.js!./invoice.component.css");

        if (typeof result === "string") {
            module.exports = result;
        } else {
            module.exports = result.toString();
        }
    


//////////////////
// WEBPACK FOOTER
// ./src/app/invoice/invoice.component.css
// module id = 488
// module chunks = 2